import get from "lodash/get";

export const isExpanded = state =>
  get(state, "navigationSidebar.isExpanded", false);
